import { useCallback } from 'react';

import { Address } from 'viem';

import { useUpdateConfigLm } from '@services/api/vaults/vaults.api';

import { useAuth } from '@contexts/common/AuthorizationContext';

import { useSignMessage } from '@hooks/common/useSignMessage';

interface Params {
  vaultId: number;
  farmId: number;
  isAilmEnabled: boolean;
  isAlmEnabled: boolean;
}

interface UseUpdateConfigLmAction {
  handleUpdate: () => Promise<void>;
}

export const useUpdateConfigLmAction = ({
  handleUpdate,
}: UseUpdateConfigLmAction) => {
  const { account } = useAuth();
  const { signData } = useSignMessage();

  const { mutateAsync, isPending } = useUpdateConfigLm();

  const updateLmConfig = useCallback(
    async (params: Params) => {
      if (!account) return null;

      const { vaultId, farmId, isAilmEnabled, isAlmEnabled } = params;

      const data = {
        vaultId,
        farmId,
        account: account.toLowerCase() as Address,
        isAilmEnabled,
        isAlmEnabled,
        timestamp: Date.now(),
      };

      const signature = await signData(data);
      const response = await mutateAsync({ data, signature });
      await handleUpdate();

      return response;
    },
    [account, mutateAsync, signData, handleUpdate],
  );

  return {
    updateLmConfig,
    isPending,
  };
};
